(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('skillSearch', skillSearch);

    function skillSearch() {
        return {
            templateUrl: '/app/directives/skill-search.tpl.html',
            scope: {
                selectedFilter: '=',
                selectedFilters: '='
            },
            controller: SkillSearchController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function SkillSearchController(dataService) {
        var vm = this;

        vm.search = search;

        function search(text) {
            return dataService
                .searchSkills(text)
                .then(response => {
                    var filters = vm.selectedFilters || [];
                    return response.results;
                });
        }
    }

})();